export const SMOKE_TAGGED_COLLECTIONS = [
  'students',
  'feedbackTemplates',
  'feedbackInstances',
  'feedbackResponses',
  'users',
  'studentEvaluations',
  'meetings',
  'meetingDefaults',
  'genEdHours',
  'extendedAccess',
  'extendedAccessStudents',
  'aideSchedules',
  'testingAttendance',
  'testingSessionNotes',
  'testingCalendarEvents',
  'schools',
  'refDocuments',
  'backups',
  'pdfMetadata',
  'pdfAccessLogs',
  'config',
  'devSmokeFixtures'
]

/** Fixed-id probe docs (not queryable by __smokeTest on every path). */
export const SMOKE_PROBE_DOCS = [
  ['app_settings', 'smoke_probe'],
  ['emailConfig', 'smoke_probe']
]

/** issueReports cannot carry __smokeTest (closed field list). */
export const SMOKE_ISSUE_REPORT_ROUTE = '/__smoke_test__'

/** studentPrivate cannot carry __smokeTest; orphan writes use this studentId prefix. */
export const SMOKE_PRIVATE_STUDENT_ID_PREFIX = 'SMOKE-PRIV-'

/** Storage prefixes the Admin SDK leftover sweep also deletes. */
export const SMOKE_STORAGE_PREFIXES = ['refDocuments/smoke_', 'admin/backups/smoke_']
